(function () {
  function handleSwatchClick(event) {
    const button = event.target.closest('.card-product-swatches__button');
    if (!button) return;

    const card = button.closest('[data-card-product]');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const imageSrc = button.dataset.variantImage;
    const imageAlt = button.dataset.variantImageAlt || '';
    const mainImage = card.querySelector('.card-product__image--main');
    const secondaryImage = card.querySelector('.card-product__image--secondary');

    if (mainImage && imageSrc) {
      mainImage.src = imageSrc;
      mainImage.removeAttribute('srcset');
      mainImage.alt = imageAlt;

      if (secondaryImage) {
        secondaryImage.src = imageSrc;
        secondaryImage.removeAttribute('srcset');
        secondaryImage.alt = imageAlt;
      }
    }

    card.querySelectorAll('.card-product-swatches__button').forEach((swatchButton) => {
      const isActive = swatchButton === button;
      swatchButton.classList.toggle('card-product-swatches__button--active', isActive);
      swatchButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  document.addEventListener('click', handleSwatchClick, true);
})();
